import PhoneNumber from "awesome-phonenumber";

export const normalizeEmail = (email?: string | null): string => {
  if (!email) return email || "";
  return email.trim().toLowerCase();
};

/**
 * Normalizes to E.164 (e.g. "+14076548727"). Falls back to a digits-only
 * representation (with a "+" prepended) if the value can't be parsed, so
 * saves never throw on malformed legacy data.
 */
export const normalizePhone = (phone?: string | null): string => {
  if (!phone) return phone || "";

  const parsed = new PhoneNumber(phone, "US");
  if (parsed.isValid()) {
    return parsed.getNumber();
  }

  const digits = phone.replace(/\D/g, "");
  if (!digits) return phone;
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return `+${digits}`;
};
